<template>
    <section class="testmonials">
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h3>Depoimentos</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <div class="row">
                        <div class="col-md-12">
                            <div id="carouselTestimonials" class="carousel slide" data-ride="carousel" data-interval="false">
                                <div class="carousel-inner">
                                    <div class="carousel-item" v-for="(depo, i ) of data.testimonials" :class="{ active: (i === data.current) }">
                                        <div class="container">
                                            <div class="row justify-content-md-center">
                                                <div class="col-md-8">
                                                    <div class="card">
                                                        <p>{{ depo.text }}</p>
                                                        <h5>{{ depo.author }}</h5>
                                                        <h6>{{ depo.business }}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <a class="carousel-control-prev" href="#carouselTestimonials" role="button" data-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Previous</span>
                                </a>
                                <a class="carousel-control-next" href="#carouselTestimonials" role="button" data-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Next</span>
                                </a>
                                <div>
                                    <ol class="carousel-indicators">
                                        <li data-target="#carouselTestimonials" v-for="(depo, i) of data.testimonials" data-slide-to="i" :class="{ active: (i === data.current) }"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                data: {
                    current: 0,
                    testimonials: [
                        {
                            text: 'Através da Pró-reitoria de Comunicação e Tecnologia da Informação da UFPE, a Viitra desenvolveu produtos que revolucionaram a comunicação interna da nossa instituição. O Portal do Estudante, o UFPE Mobile e o Sinalização Digital agilizaram e facilitaram o acesso à informação dentro do Campus. Recentemente, a empresa padronizou e automatizou todo processo de controle de estágios, por meio do Sistema de Estágios. Participei diretamente do desenvolvimento desses produtos e posso atestar a competência e profissionalismo com que a Viitra desenvolveu e mantém serviços de enorme relevância para toda comunidade da UFPE.',
                            author: 'Ricardo Massa',  
                            business: 'Professor, UFPE'
                        },
                        {
                            text: 'A equipe da Viitra atuou com muita presteza e empatia, mobilizando pessoas competentes para ouvir nossa demanda complexa e executando um trabalho com segurança, pontualidade e cortesia ao longo de todo o processo. Parabéns a todos e muito obrigado!',
                            author: 'Alex Gomes',
                            business: 'Coordenador, Projeto Samsung'
                        },
                    ]
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Testimonials.carousel.vue